import { apiSendJson, apiSend } from "@/api/apicommon"

export default {
    async getWidgetToken() {
        const method = "POST"
        const endpoint = "/posos/widget-token"
        return await apiSend(method, endpoint)
    },
    async getAnalysisData(patientId: string) {
        const method = "GET"
        const endpoint = `/posos/analysis-data/${patientId}`
        return await apiSendJson(method, endpoint, undefined)
    },
}